import { render, staticRenderFns } from "./IconUsersOutline.vue?vue&type=template&id=859601e0"
import script from "./IconUsersOutline.vue?vue&type=script&lang=js"
export * from "./IconUsersOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports